import { Clock, Phone, Mail, MapPin, MessageCircle, Zap, HeadphonesIcon, Calendar } from "lucide-react";
import { schoolInfo } from "../../mock/mock";

const promises = [
  { icon: Zap, label: "Fast Reply", desc: "We respond to every enquiry within 24 hours (usually within 4)", color: "from-orange-500 to-red-500" },
  { icon: HeadphonesIcon, label: "Real Humans", desc: "Speak directly with the founder or admissions team — never a bot", color: "from-amber-500 to-orange-600" },
  { icon: Calendar, label: "Free School Tour", desc: "Visit our Jaipur campus with your child once we launch Jan 2027", color: "from-emerald-500 to-teal-600" }
];

const channels = [
  { icon: Phone, label: "Call Us", value: schoolInfo.phone, sub: "Mon-Sat, 9am-6pm IST", href: `tel:${schoolInfo.phone}`, color: "from-sky-500 to-blue-600" },
  { icon: MessageCircle, label: "WhatsApp", value: schoolInfo.phone, sub: "Fastest response — try us!", href: `https://wa.me/${schoolInfo.phone.replace(/[^0-9]/g, "")}`, color: "from-emerald-500 to-green-600" },
  { icon: Mail, label: "Email", value: schoolInfo.email, sub: "For detailed enquiries", href: `mailto:${schoolInfo.email}`, color: "from-fuchsia-500 to-purple-600" },
  { icon: MapPin, label: "Visit Us", value: "Jaipur, Rajasthan", sub: "Full address after launch", href: "#", color: "from-orange-500 to-red-600" }
];

const ContactInfographic = () => (
  <section className="py-16 bg-white" data-testid="contact-infographic">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">How We Respond</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">Our Promise to Every Parent</h2>
        <p className="text-stone-600 text-sm md:text-base">
          The way we answer your first message is a preview of the care we'll give your child. Here's what to expect.
        </p>
      </div>

      {/* Promises */}
      <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto mb-12">
        {promises.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.label} className="p-5 rounded-3xl bg-gradient-to-br from-orange-50 to-amber-50 border border-orange-100 shadow-md hover:shadow-xl transition-all" data-testid={`promise-${p.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${p.color} flex items-center justify-center shadow mb-3`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-display text-lg font-bold text-stone-800 mb-1">{p.label}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{p.desc}</p>
            </div>
          );
        })}
      </div>

      {/* Channels */}
      <div className="max-w-5xl mx-auto">
        <h3 className="font-display text-xl font-bold text-stone-800 text-center mb-6">Reach us the way that suits you</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {channels.map((c) => {
            const Icon = c.icon;
            return (
              <a
                key={c.label}
                href={c.href}
                target={c.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                className="group p-5 rounded-3xl bg-white border border-orange-100 shadow-md hover:shadow-2xl transition-all hover:-translate-y-1 text-center"
                data-testid={`channel-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${c.color} flex items-center justify-center shadow mx-auto mb-3 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <p className="text-[10px] font-bold text-stone-500 uppercase tracking-widest mb-1">{c.label}</p>
                <p className="font-display font-bold text-stone-800 text-sm break-words">{c.value}</p>
                <p className="text-xs text-stone-500 mt-1">{c.sub}</p>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default ContactInfographic;
